import { API_AUTH } from ".././common";

const ChoThanhToanApi = {
  list: ({ sSearch, sTrangThai, iPageSize, iPageIndex, TuNgay, DenNgay, iLoaiChoVay }) =>
    API_AUTH.get(
      `chothanhtoan/danhsach?sSearch=${sSearch}&sTrangThai=${sTrangThai}&iPageSize=${iPageSize}&iPageIndex=${iPageIndex}&TuNgay=${TuNgay}&DenNgay=${DenNgay}&iLoaiChoVay=${iLoaiChoVay}`,
      {}
    ),
  saveChoThanhToanTatToan: (params) => API_AUTH.post("chothanhtoan/SaveChoThanhToanTatToan", params),
  saveChoThanhToanDongLai: (params) => API_AUTH.post("chothanhtoan/SaveChoThanhToanDongLai", params),
  deleteChoThanhToan: ({ idChoThanhToan }) => API_AUTH.post("chothanhtoan/delete?idChoThanhToan=" + idChoThanhToan),

};

export default ChoThanhToanApi;
